import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import { useWealthSavingsProductsContent } from '../../../../hooks/useWealthSavingsProductsContent';
import './Products.css';

const Products = () => {
  const { content, isLoading } = useWealthSavingsProductsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, linkText, items } = content;

  return (
    <section className="wealth-products">
      <div className="wealth-products__inner">
        <Reveal>
          <h2 className="wealth-products__title">{title}</h2>
        </Reveal>

        <div className="wealth-products__grid">
          {items.map(({ tagline, title: productTitle, cardText, url }, index) => (
            <Reveal key={`${productTitle}-${index}`} delay={index * 80}>
              <article className="wealth-products__card">
                <div className="wealth-products__card-top">
                  <p className="wealth-products__tagline">{tagline}</p>
                  <h3 className="wealth-products__card-title">{productTitle}</h3>
                </div>

                <div className="wealth-products__card-bottom">
                  <p className="wealth-products__card-text">{cardText}</p>
                  {url ? (
                    <Link to={url} className="wealth-products__card-link">
                      {linkText}
                      <HiArrowRight
                        className="wealth-products__card-link-icon"
                        aria-hidden="true"
                      />
                    </Link>
                  ) : null}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
